import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Button } from "reactstrap";
import { QuestionAlertTitle, QuestionsState } from "../../../constants";
import { QuestionAlertSubTitle } from "../../../data/bonusUi/SweetAlert";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const QuestionAlert = () => {
  const buttonStyle = Swal.mixin({
    customClass: {
      cancelButton: "btn-primary",
    },
    buttonsStyling: true,
  });
  const handleAlert = () => {
    buttonStyle.fire({
      text: "Are you sure you want to do this?",
      showCancelButton: true,
      cancelButtonText: "Aww yess!",
      confirmButtonText: "oh noez!",
      confirmButtonColor: "gray",
    });
  };
  return (
    <Col xxl="3" lg="4" sm="6" xs="12">
      <Card>
        <CommonCardHeader title={QuestionAlertTitle} span={QuestionAlertSubTitle} />
        <CardBody className="btn-showcase">
          <Button color="primary" onClick={handleAlert}>
            {QuestionsState}
          </Button>
        </CardBody>
      </Card>
    </Col>
  );
};
export default QuestionAlert;
